import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-pasar-refuerzo',
  templateUrl: './pasar-refuerzo.component.html',
  styleUrls: ['./pasar-refuerzo.component.scss']
})
export class PasarRefuerzoComponent implements OnInit {

  public notas: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private _informe: InformesService, private _snackBar: MatSnackBar, private dialogRef: MatDialogRef<PasarRefuerzoComponent>) { }

  ngOnInit() {
    
  }

  public pasarRefuerzo(){
    this._informe.PasarRefuerzo(this.datos.document, this.notas).subscribe((data:any) => {
      if(data.estatus == 1){
        this._snackBar.open('Se ha guardado el beneficiario', 'Aceptar', {
          duration: 2000,
        });
        this.dialogRef.close(true);
      }else if(data.estatus == 0){
        this._snackBar.open('Error al actualizar beneficiario', 'Aceptar', {
          duration: 2000,
        })
      }
    });
  }

}
